import { render, staticRenderFns } from "./Fortunes.vue?vue&type=template&id=96128de2&scoped=true&"
import script from "./Fortunes.vue?vue&type=script&lang=js&"
export * from "./Fortunes.vue?vue&type=script&lang=js&"
import style0 from "./Fortunes.vue?vue&type=style&index=0&id=96128de2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96128de2",
  null
  
)

export default component.exports